import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography, List, ListItem, ListItemText } from "@mui/material";
import apiClient from "../../services/apiClient";
import SEO from "../../components/SEO";

function StatCard({ label, value }) {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Typography variant="h5">{value}</Typography>
    </Paper>
  );
}

export default function AdminDashboardPage() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    apiClient.request("/api/admin/dashboard").then(setStats).catch(() => setStats(null));
  }, []);

  if (!stats) return <Typography>Chargement du dashboard...</Typography>;

  return (
    <>
      <SEO title="Admin Dashboard | DigiBuddy" noIndex noFollow />
      <Typography variant="h4" sx={{ mb: 2 }}>Dashboard</Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} md={3}><StatCard label="Total leads" value={stats.totalLeads} /></Grid>
        <Grid item xs={12} md={3}><StatCard label="Nouveaux 7 jours" value={stats.newLeads7} /></Grid>
        <Grid item xs={12} md={3}><StatCard label="Nouveaux 30 jours" value={stats.newLeads30} /></Grid>
        <Grid item xs={12} md={3}><StatCard label="Rendez-vous pris" value={stats.callBooked} /></Grid>
        <Grid item xs={12} md={3}><StatCard label="Guide telecharge" value={stats.guideDownloaded} /></Grid>
        <Grid item xs={12} md={3}><StatCard label="Emails en attente" value={stats.pendingEmails} /></Grid>
        <Grid item xs={12} md={3}><StatCard label="Emails envoyes" value={stats.sentEmails} /></Grid>
        <Grid item xs={12} md={3}><StatCard label="Emails echoues" value={stats.failedEmails} /></Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Prochains emails</Typography>
            <List dense>
              {stats.nextEmails?.map((row) => (
                <ListItem key={row.id}>
                  <ListItemText
                    primary={`${row.lead?.email || "Lead"} - ${row.sequence_step_key || row.email_type}`}
                    secondary={row.scheduled_at ? new Date(row.scheduled_at).toLocaleString() : "-"}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Derniers evenements</Typography>
            <List dense>
              {stats.latestEvents?.map((row) => (
                <ListItem key={row.id}>
                  <ListItemText
                    primary={row.label}
                    secondary={`${row.lead?.email || "Lead"} - ${new Date(row.created_at).toLocaleString()}`}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
